import PromiseBB from "bluebird";
import * as React from "react";
import { ListGroup } from "react-bootstrap";
import { DragSource, DropTarget } from "react-dnd";
import * as ReactDOM from "react-dom";
import { ContextMenu } from "../../../controls/api";
import * as util from "../../../util/api";
import { ComponentEx } from "../../../controls/ComponentEx";
class DraggableItem extends React.Component {
    render() {
        const { isDragging, item, isLocked } = this.props;
        const classNames = [].concat(isLocked ? "locked" : undefined, !!item.external ? "external" : undefined, isDragging ? "dragging" : undefined);
        return (React.createElement(this.props.itemRenderer, { className: classNames.filter((name) => !!name).join(" "), item: item, onRef: this.setRef, onContextMenu: this.props.onContextMenu }));
    }
    setRef = (ref) => {
        const { connectDragSource, connectDropTarget } = this.props;
        const node = ReactDOM.findDOMNode(ref);
        connectDragSource(node);
        connectDropTarget(node);
    };
}
const DND_TYPE = "load-order-entry";
function collectDrag(connect, monitor) {
    return {
        connectDragSource: connect.dragSource(),
        isDragging: monitor.isDragging(),
    };
}
function collectDrop(connect, monitor) {
    return {
        connectDropTarget: connect.dropTarget(),
    };
}
const entrySource = {
    beginDrag(props) {
        return {
            index: props.index,
            item: props.item,
            containerId: props.containerId,
            take: (list) => props.take(props.item, list),
        };
    },
    endDrag(props, monitor) {
        props.apply();
    },
    canDrag(props, monitor) {
        return !props.isLocked;
    },
};
const entryTarget = {
    hover(props, monitor, component) {
        const { containerId, index, item, take, isLocked } = monitor.getItem();
        const hoverIndex = props.index;
        if (index === hoverIndex || !!isLocked || !!props.isLocked) {
            return;
        }
        const domNode = ReactDOM.findDOMNode(component);
        if (domNode === null) {
            return;
        }
        const hoverBoundingRect = domNode.getBoundingClientRect();
        const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
        const clientOffset = monitor.getClientOffset();
        const hoverClientY = clientOffset.y - hoverBoundingRect.top;
        if ((index < hoverIndex && hoverClientY < hoverMiddleY) ||
            (index > hoverIndex && hoverClientY > hoverMiddleY)) {
            return;
        }
        props.onChangeIndex(index, hoverIndex, take);
        monitor.getItem().index = hoverIndex;
        if (containerId !== props.containerId) {
            monitor.getItem().containerId = props.containerId;
            monitor.getItem().take = (list) => props.take(item, list);
        }
    },
    drop(props) {
        props.apply();
    },
};
const Draggable = DropTarget(DND_TYPE, entryTarget, collectDrop)(DragSource(DND_TYPE, entrySource, collectDrag)(DraggableItem));
class DraggableList extends ComponentEx {
    applyDebouncer;
    constructor(props) {
        super(props);
        this.initState({
            ordered: props.items.slice(0),
            contextMenuVisible: false,
            offset: { x: 0, y: 0 },
            contextHistory: {
                previous: undefined,
                current: undefined,
            },
        });
        this.applyDebouncer = new util.Debouncer((list) => {
            this.props.apply(list);
            return PromiseBB.resolve();
        }, 300, false, true);
    }
    UNSAFE_componentWillReceiveProps(newProps) {
        if (this.nextState.ordered !== newProps.items) {
            this.nextState.ordered = newProps.items.slice(0);
        }
    }
    render() {
        const { connectDropTarget, id, itemRenderer, loadOrder } = this.props;
        const { ordered } = this.state;
        return connectDropTarget(React.createElement("div", null,
            React.createElement(ListGroup, null, ordered.map((item, idx) => (React.createElement("div", { key: item.id + idx.toString() },
                React.createElement(Draggable, { containerId: id, item: item, index: idx, itemRenderer: itemRenderer, take: this.take, onChangeIndex: this.changeIndex, onContextMenu: this.onContextMenu, apply: this.apply, isLocked: !!loadOrder[item.id]?.locked || !!item?.locked }),
                this.renderContextMenu(item)))))));
    }
    changeIndex = (oldIndex, newIndex, take) => {
        const { loadOrder } = this.props;
        const { ordered } = this.state;
        if (oldIndex === undefined) {
            return;
        }
        const itemLocked = (idx) => !!ordered[idx]?.locked || !!loadOrder[ordered[idx]?.id]?.locked;
        if (itemLocked(newIndex) === true) {
            return;
        }
        const copy = ordered.slice();
        const currentItem = take(copy);
        const replacedItem = ordered[newIndex];
        copy.splice(newIndex, 0, currentItem);
        const conditions = [currentItem?.condition, replacedItem?.condition].filter((cond) => !!cond);
        const failedConditions = conditions.reduce((accum, cond) => {
            const condRes = cond(currentItem, replacedItem, copy);
            if (condRes !== undefined && !condRes.success) {
                accum.push(condRes);
            }
            return accum;
        }, []);
        if (failedConditions.length > 0) {
            // TODO: need to write a custom drag layer to display
            //  some sort of feedback to the user explaining why he's
            //  unable to change the index of the dragged item (preferably on hover).
            //  for now, we will have to rely on the extensions themselves to
            //  display this information to the user... ugh..
            // currentItem.message = failedConditions.map(failed => failed.errMessage || '').join(' - ');
            return;
        }
        // currentItem.message = undefined;
        this.nextState.ordered = copy;
        this.applyDebouncer.schedule(undefined, copy);
    };
    renderContextMenu = (item) => {
        const { contextMenuVisible, offset, contextHistory } = this.state;
        const isTargetItem = contextHistory?.current !== undefined
            ? contextHistory.current.indexOf(item.name) !== -1
            : false;
        return isTargetItem && !!item?.contextMenuActions ? (React.createElement(ContextMenu, { key: "lo-entry-context-menu", actions: item.contextMenuActions, position: offset, visible: contextMenuVisible, onHide: this.onHide, instanceId: item.id })) : null;
    };
    onHide = () => {
        this.nextState.contextMenuVisible =
            this.state.contextHistory.current === this.state.contextHistory.previous
                ? false
                : true;
        this.nextState.contextHistory.previous =
            this.nextState.contextHistory.current;
    };
    onContextMenu = (evt) => {
        this.nextState.contextMenuVisible = true;
        this.nextState.contextHistory.current = evt.target.innerText;
        this.nextState.offset = { x: evt.clientX, y: evt.clientY };
    };
    take = (item, list) => {
        const { ordered } = this.nextState;
        let res = item;
        const index = ordered.findIndex((entry) => entry.id === item.id);
        if (index !== -1) {
            if (list !== undefined) {
                res = list.splice(index, 1)[0];
            }
            else {
                const copy = ordered.slice();
                res = copy.splice(index, 1)[0];
                this.nextState.ordered = copy;
            }
        }
        return res;
    };
    apply = () => {
        this.props.apply(this.state.ordered);
    };
}
const containerTarget = {
    hover(props, monitor, component) {
        const { containerId, index, item, take } = monitor.getItem();
        if (containerId !== props.id) {
            component.changeIndex(index, 0, take);
            monitor.getItem().index = 0;
            monitor.getItem().containerId = props.id;
            monitor.getItem().take = (list) => component.take(item, list);
        }
    },
};
function containerCollect(connect, monitor) {
    return {
        connectDropTarget: connect.dropTarget(),
    };
}
export default DropTarget(DND_TYPE, containerTarget, containerCollect)(DraggableList);
